var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeciality5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d,.e,.f{fill:none;stroke:#208ce1;stroke-width:1.5px;}.e,.f{stroke-linecap:round;}.e{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-736 -7460)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-2125 3517)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.374 0.203)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-754.434-7429.5s-2.321-3.962-.283-9.679,2.207-7.98.623-9.509a10.909,10.909,0,0,0-1.378-1.275l2.813-3.148"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-747.167-7444.5s-3.539-1.22-4.086-4.015a7.441,7.441,0,0,1,0-3.871c-.857-.7-1.872-1.687-1.872-1.687l1.375-1.672,1.766,1.469,1.125-1.016-.422-2.125,2.115-.781.495,1.859h1.891l.125-1.859,2.188.188-.109,2a7.7,7.7,0,0,1,1.766,1.938c1.016-.219,3.484-1.469,4.438-1.812s1.359-.469,1.609-.375a47.482,47.482,0,0,1,1.969,4.922s.719,1.313-.109,1.594-1.859.656-1.859.656-6.859,1.333-4.765,12.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-752.1-7439.609s4.489.521,5.685-5.917a11.609,11.609,0,0,1,6.01-8.536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-736.918-7447.917s10.559,1.508,10.332,17.648"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-751.776-7423.784s7.275,10.341,18.588,9.355"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-729.753-7422.8h-4.978v5.657h4.978v4.827h5.506v-4.827h5.129v-5.657h-4.827v-4.751h-5.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-763.374-7426.967h4.02l1.569-3.53,1.667,8.138,1.863-4.608h3.638l1.951-4.412,1.863,8.432,1.078-4.02h4.51"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality5);
export default __webpack_public_path__ + "static/media/speciality5.7ec96bb145544e806f26678bf8bbfdf0.svg";
export { ForwardRef as ReactComponent };